export default "/static/images/build_middle_7.png?e6320ae8e3f99e445d853b883c2ac7f1";